var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgVoice = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30964 9.19256V4.41541C6.30964 3.07352 7.46446 2 8.85024 2C10.236 2 11.4486 3.07352 11.4486 4.41541V9.19256C11.4486 10.5345 10.2938 11.608 8.85024 11.608C7.40672 11.608 6.30964 10.4808 6.30964 9.19256ZM13.816 8.38743C13.816 8.0117 13.4695 7.74332 13.1231 7.74332C12.7766 7.74332 12.4879 7.95802 12.4302 8.28008V8.38743V8.4411V8.49478V8.60213C12.4302 9.89035 12.1415 10.8565 11.5641 11.5006C10.9867 12.1984 10.1205 12.5741 8.96573 12.5741C7.81091 12.5741 6.82931 12.1447 6.2519 11.447C5.67449 10.8028 5.38578 9.783 5.38578 8.54845V8.49478V8.4411C5.38578 8.38743 5.38578 8.38743 5.38578 8.38743V8.33375C5.32804 8.0117 5.03934 7.79699 4.69289 7.79699C4.28871 7.79699 4 8.11905 4 8.4411C4 12.5741 6.2519 13.7013 8.21509 13.916V14.8822H7.06027C6.71383 14.8822 6.36738 15.1506 6.36738 15.5263V15.6337C6.36738 15.9557 6.65609 16.2778 7.06027 16.2778H10.8712C11.2176 16.2778 11.5641 16.0094 11.5641 15.6337V15.5263C11.5641 15.2043 11.2754 14.8822 10.8712 14.8822H9.71636V13.916C11.5641 13.6477 13.816 12.5205 13.816 8.38743Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgVoice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/voice.5f5d7f20ac8fea13e94edf06da5c3b77.svg";